module.exports = require("core-js-pure/stable/number/max-safe-integer");


//////////////////
// WEBPACK FOOTER
// ./~/@babel/runtime-corejs3/core-js-stable/number/max-safe-integer.js
// module id = L1Nm
// module chunks = 0